import React, { Component } from "react";
function Nav(props) {
  let { toggleMenu } = props;
  const { MenuIcon } = props;
  // Scroll to selected section
  window.onscroll = () => {
    let header = document.querySelector(".header");
    header.classList.toggle("sticky", window.scrollY > 100);
  };
  return (
    <div>
      <nav class="navbar" id={`${toggleMenu}`}>
        <a
          href="#Home"
          onClick={() => {
            const anchor = document.querySelector("#home");
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            MenuIcon();
          }}
        >
          Home
        </a>

        <a
          href="#About"
          onClick={() => {
            const anchor = document.querySelector("#about");
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            MenuIcon();
          }}
        >
          About
        </a>

        <a
          href="#Skills"
          onClick={() => {
            const anchor = document.querySelector("#skills");
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            MenuIcon();
          }}
        >
          Skills
        </a>

        <a
          href="#Experience"
          onClick={() => {
            const anchor = document.querySelector("#resume");
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            MenuIcon();
          }}
        >
          Experience
        </a>

        <a
          href="#Projects"
          onClick={() => {
            const anchor = document.querySelector("#portfolio");
            anchor.scrollIntoView({ behavior: "smooth", block: "start" });
            MenuIcon();
          }}
        >
          Projects
        </a>

        <a
          href="#Contaxt"
          id="contactme"
          onClick={() => {
            const anchor = document.querySelector("#contact");
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            MenuIcon();
          }}
        >
          Contact
        </a>
      </nav>
    </div>
  );
}
export default Nav;
